module.exports = __webpack_public_path__ + "static/img/应用场景1-车机中控.3cd5baf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type3-5/应用场景1-车机中控.png
// module id = ozY7
// module chunks = 0